import React from 'react';
import Payment from '@material-ui/icons/Payment';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import { Avatar, makeStyles } from '@material-ui/core';
import { red, blue, orange } from '@material-ui/core/colors';
import Warning from '@material-ui/icons/WarningRounded';

const useStyles = makeStyles((theme) => ({
  proforma: {
    color: red[500],
    backgroundColor: 'white'
  },
  total: {
    color: blue[500],
    backgroundColor: 'white'
  },
  deposit: {
    color: orange[500],
    backgroundColor: 'white'
  }
}));

const iconConfig = {
  customer: <Payment />,
  partner: <SupervisedUserCircleIcon />
};

interface NotificationAvatarProps {
  type: string; // 'deposit' | 'total' | 'proforma';
  paymentType: string; // 'customer' | 'partner';
  isDelayed?: boolean;
}

const NotificationAvatar = ({ type, paymentType, isDelayed }: NotificationAvatarProps) => {
  const style = useStyles();
  if (isDelayed) {
    return (
      <Avatar aria-label="name" className={style.proforma}>
        <Warning />
      </Avatar>
    );
  }

  return (
    <Avatar aria-label="name" className={style[type]}>
      {iconConfig[paymentType]}
    </Avatar>
  );
};

export default NotificationAvatar;
